import { render, staticRenderFns } from "./VesselContactCard.vue?vue&type=template&id=737e64ff"
import script from "./VesselContactCard.vue?vue&type=script&lang=ts"
export * from "./VesselContactCard.vue?vue&type=script&lang=ts"
import style0 from "./VesselContactCard.vue?vue&type=style&index=0&id=737e64ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports